<template>
    <div v-if="NotificationsController.zones_count[zone]"
      :class="`container-alert ${zone} ${content_class}`">
        <div v-for="notification in NotificationsController.zones[zone]"
            :key="'n_m_' + notification.id" class="alert" :class="notification.type">
            <div class="alert-icon">
                <i :class="icons[notification.type]" aria-hidden="true"></i>
            </div>

            <component
              :is="partials[notification.message_type] || partials.default"
              :notification="notification" />

            <div @click="onDismiss(notification.id)" class="alert-close">
                <i class="far fa-times-circle"></i>
            </div>
        </div>
    </div>
</template>

<script setup>
  import { defineProps }          from 'vue';
  import NotificationsController  from '@/js/Webmail/Notifications/NotificationsController.js';
  import Text                     from './Partials/Text.vue';
  import TextLink                 from './Partials/TextLink.vue';

  const icons  = {
    'error' :   'fas fa-exclamation-circle',
    'warning' : 'fas fa-exclamation-circle',
    'success' : 'fas fa-check-circle',
    'info' :    'fas fa-info-circle',
  }

  const props = defineProps({
    zone: {
      type: String,
      default: 'float'
    },
    content_class: {
      type: String,
      default: '',
    }
  });

  const partials = {
    'text' : Text,
    'text_link': TextLink,
    'default': Text,
  }

  const onDismiss = (id) => {
    NotificationsController.removeNotification(id, props.zone);
  }
</script>
